import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import Approuter from "./Routes/Approuter";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/css/line-awesome.min.css";
import "./assets/scss/main.scss";
import "./assets/css/material.css";
import "./assets/css/custom.css";
import "./assets/css/hms.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { GlobalDataProvider } from "./views/context/GlobalDataContext"; // Adjust the path
import { PosProvider } from "./views/context/PosContext"; // Adjust the path
import { HospitalityProvider } from "./views/context/HospitalityContext"; // New import
import  useVersionChecker from "./hook/VersionChecker";
import { NotificationProvider  } from "./views/context/NotificationContext";

import VersionNotificationModal from "../src/views/pages/hms/components/popups/VersionNotificationModal";

const RootComponent = () => {
  const [loading, setLoading] = useState(true);
  const isUpdateAvailable = useVersionChecker();
  const [showReload, setShowReload] = useState(false);





  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the delay as needed

    return () => clearTimeout(loadingTimeout);
  }, []);


  const handleReload = () => {
    window.location.reload(true);
  };

  return (
    //<React.StrictMode>
      <GlobalDataProvider>
        <PosProvider>
            <NotificationProvider>
          <HospitalityProvider> {/* Add the new provider */}
            {loading ? (
              <div id="loader-wrapper">
                <div className="loader">
                  <img
                    src="https://netshine-assets.blr1.cdn.digitaloceanspaces.com/web-assets/logo-light.png"
                    alt="Logo"
                    className="loader-logo"
                  />
                  <div className="dots" style={{ marginLeft: "40px" }}>
                    <div className="dot" style={{ width: "14px", height: "14px" }}></div>
                    <div className="dot" style={{ width: "14px", height: "14px" }}></div>
                    <div className="dot" style={{ width: "14px", height: "14px" }}></div>
                    <div className="dot" style={{ width: "14px", height: "14px" }}></div>
                    <div className="dot" style={{ width: "14px", height: "14px" }}></div>
                  </div>
                </div>
              </div>
            ) : (
              <Approuter />
            )}


          </HospitalityProvider>
         </NotificationProvider> 
        </PosProvider>
      </GlobalDataProvider>
    //</React.StrictMode>
  );
};

// Use React 18's createRoot for rendering
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(<RootComponent />);